import { Box, styled, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { Row } from '../Layout';

const LabelWrapper = styled('div')(({ theme }: { theme: Theme }) => ({
  ...theme.typography.h5,
}));

const StyledBox = styled(Box)(({ theme }) => ({
  width: 24,
  height: 24,
  borderRadius: '50%',
  backgroundColor: theme.palette.common.black,
  color: theme.palette.common.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  alignSelf: 'flex-start',
  flexShrink: 0,
  fontSize: theme.typography.body2.fontSize,
}));

type Props = {
  index: number | string;
  label?: ReactNode;
  spacing?: keyof Theme['spacingSizes'];
};

const StepIndex: FC<Props> = ({ index, spacing = 'sm', label }) => {
  return (
    <Row spacing={spacing}>
      <StyledBox>{index}</StyledBox>
      {label ? <LabelWrapper>{label}</LabelWrapper> : null}
    </Row>
  );
};

export default StepIndex;
